import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, Checkbox } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import SubmitButton from "components/common/SubmitButton";

const EditBillingTemplate = ({ cancelEdit, onSubmit, isLoading, item }) => {
  const [submitAttempted, setSubmitAttempted] = React.useState(false);

  const validateForm = (values) => {
    const errors = {};
    if (!values.templateName || values.templateName.trim() === "") {
      errors.templateName = "Template name is required";
    }
    return errors;
  };
  console.log("EditBillingTemplate item:", item);

  return (
    <Dialog
      title={item ? `Edit ${item.templateName}` : "Add Billing Template"}
      onClose={cancelEdit}
      width={600}
    >
      <Form
        onSubmit={onSubmit}
        initialValues={{ active: true, ...item }}
        validator={validateForm}
        render={(formRenderProps) => (
          <>
            <div className="p-3 ps-4">
              <FormElement style={{ maxWidth: 1200 }}>
                <fieldset className="k-form-fieldset">
                  <div className="mb-2">
                    <Label className="label mt-1 mb-2 w-100">
                      Template Name
                    </Label>
                    <Field
                      name="templateName"
                      component={Input}
                      placeholder="Enter template name"
                    />
                    {submitAttempted &&
                      formRenderProps.errors?.templateName && (
                        <div className="fs-sm my-1 text-danger">
                          <i>{formRenderProps.errors.templateName}</i>
                        </div>
                      )}
                  </div>
                  <Field name="active" component={Checkbox} label="Active" />
                </fieldset>
              </FormElement>
            </div>
            <div className="dialog-footer">
              <button
                className="bgBtnSecondary common-btn me-2"
                onClick={cancelEdit}
              >
                Cancel
              </button>
              <SubmitButton
                className="me-3"
                isLoading={isLoading}
                onClick={() => {
                  setSubmitAttempted(true);
                  formRenderProps.onSubmit();
                }}
                disabled={!formRenderProps.allowSubmit}
              >
                {item ? "Update" : "Save"}
              </SubmitButton>
            </div>
          </>
        )}
      />
    </Dialog>
  );
};

export default EditBillingTemplate;
